// extracted by mini-css-extract-plugin
export default {"healthSupportItem":"_1f1NiSdaegD6srRC2r-2XQ","links":"_2eXxU2t6GJZ8JAUi4wV0hg"};